// src/polyfills.ts

// Polyfill for Uint8Array.toBase64
if (!Uint8Array.prototype.toBase64) {
    Object.defineProperty(Uint8Array.prototype, "toBase64", {
      value: function (options?: { alphabet?: "base64" | "base64url"; omitPadding?: boolean }): string {
        // For simplicity, ignore options in this basic implementation.
        let binary = "";
        for (let i = 0; i < this.byteLength; i++) {
          binary += String.fromCharCode(this[i]);
        }
        let b64 = btoa(binary);
        if (options?.alphabet === "base64url") {
          // Convert to base64url encoding.
          b64 = b64.replace(/\+/g, "-").replace(/\//g, "_");
        }
        if (options?.omitPadding) {
          b64 = b64.replace(/=+$/, "");
        }
        return b64;
      },
      writable: true,
      configurable: true,
    });
  }
  
  // Polyfill for Uint8Array.fromBase64
  if (!(Uint8Array as any).fromBase64) {
    Object.defineProperty(Uint8Array, "fromBase64", {
      value: function (
        b64: string,
        options?: {
          alphabet?: "base64" | "base64url";
          lastChunkHandling?: "loose" | "strict" | "stop-before-partial";
        }
      ): Uint8Array {
        // If alphabet is base64url, convert to standard base64 first.
        if (options?.alphabet === "base64url") {
          b64 = b64.replace(/-/g, "+").replace(/_/g, "/");
        }
        const binaryString = atob(b64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
      },
      writable: true,
      configurable: true,
    });
  }
  
  export {};